module.exports = __webpack_public_path__ + "static/15-eed35f9dcc6cc2f449512c383b358a46.jpg";